import { render, staticRenderFns } from "./cookieConsent.vue?vue&type=template&id=ec27cc96&scoped=true"
import script from "./cookieConsent.vue?vue&type=script&lang=js"
export * from "./cookieConsent.vue?vue&type=script&lang=js"
import style0 from "./cookieConsent.vue?vue&type=style&index=0&id=ec27cc96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec27cc96",
  null
  
)

export default component.exports